import styled from '@emotion/styled'

import { MessageType } from '../types/types'

type StateCircleStyleProps = {
  color: string
}

export type StateCircleProps = {
  state: MessageType
}

const StateCircleStyledSpan = styled.div<StateCircleStyleProps>`
  height: 13px;
  width: 13px;
  margin-right: 8px;
  background: ${props => props.color};
  border-radius: 50%;
  display: inline-block;
`
export const StateCircle = ({ state }: StateCircleProps) => {
  let stateColor = 'var(--Red-Dark)'
  if (state === 'warning') {
    stateColor = 'var(--Warn)'
  } else if (state === 'disabled') {
    stateColor = 'var(--Info)'
  } else if (state === 'success') {
    stateColor = 'var(--Success)'
  } else if (state === 'info') {
    stateColor = 'var(--Info)'
  }
  return <StateCircleStyledSpan color={stateColor} />
}
